 <template>
  <div class="col col-lg-6">
    <div>
      <label for="modalidadeTarifariaField">
        Modalidade Tarifária
        <span class="recent-updated-label" v-if="recentUpdatedField">
          <tooltip-informacao-alterada />
        </span>
        <select
          :disabled="disabled"
          id="modalidadeTarifariaField"
          v-model="model.content"
          class="form-select"
          :class="{
            'is-invalid-yellow': $v.model.content.$error && invalidYellow,
            'recent-updated': recentUpdatedField,
          }"
        >
          <option
            v-for="(modalidadeTarifaria, modalidadeTarifariaIndex) in list"
            :key="`uf_option_${modalidadeTarifariaIndex}`"
            :value="modalidadeTarifaria.modalidade"
          >
            {{ modalidadeTarifaria.modalidade }}
          </option>
        </select>
      </label>
      <div
        v-if="loading"
        style="margin-left: -50px"
        class="spinner-border spinner-border-sm"
      ></div>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import FieldTemplate from "@/components/forms/fields/empresa/FieldTemplate.vue";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
export default {
  extends: FieldTemplate,
  props: {
    list: Array,
    loading: Boolean,
    disabled: Boolean,
    modelProp: Object,
    invalidYellow: Boolean,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "modalidadeTarifaria",
        content: "",
      },
    };
  },
  validations: {
    model: {
      content: {
        required: requiredIf(function () {
          if (this.invalidYellow) {
            return true;
          }
          return false;
        }),
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}

.align-spinner {
  display: flex;
  align-items: center;
}
</style>
